const readEnv = (key, fallback) => {
  if (typeof process !== "undefined" && process.env && process.env[key] !== undefined) {
    return process.env[key];
  }
  return fallback;
};

const toBoolean = (value, fallback) => {
  if (value === true || value === false) return value;
  if (value === undefined || value === null) return fallback;
  const normalized = String(value).trim().toLowerCase();
  if (normalized === "true" || normalized === "1" || normalized === "yes") return true;
  if (normalized === "false" || normalized === "0" || normalized === "no") return false;
  return fallback;
};

export const featureFlags = {
  MEMBER_DASHBOARD_V2_ENABLED: toBoolean(
    readEnv("VUE_APP_MEMBER_DASHBOARD_V2_ENABLED", true),
    true
  ),
  ASOCOINS_ENABLED: readEnv("VUE_APP_ASOCOINS_ENABLED", "true") !== "false",
};

export const isMemberDashboardV2Enabled = () =>
  Boolean(featureFlags.MEMBER_DASHBOARD_V2_ENABLED);

export const isAsocoinsFeatureEnabled = () =>
  Boolean(featureFlags.ASOCOINS_ENABLED);

export default featureFlags;
